import React from 'react'
import './style.css'

const Loading3Dot = () => <div className="dot-falling" />

export default Loading3Dot
